
export enum PoItemEnum{
    OPEN='OPEN',
    PARTAILLY_RECEIVED='PARTAILLY RECEIVED',
    RECEIVED='RECEIVED',

}